import { render, staticRenderFns } from "./Template10.vue?vue&type=template&id=aa250fb2&scoped=true"
import script from "./Template10.vue?vue&type=script&lang=js"
export * from "./Template10.vue?vue&type=script&lang=js"
import style0 from "./Template10.vue?vue&type=style&index=0&id=aa250fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa250fb2",
  null
  
)

export default component.exports